/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateFreeeSelectCompanyRequest
 */
export interface UpdateFreeeSelectCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompanyRequest
     */
    'freeeCompanyId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompanyRequest
     */
    'freeeCompanyName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompanyRequest
     */
    'transitionModeEndDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFreeeSelectCompanyRequest
     */
    'useJournaling': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompanyRequest
     */
    'yearMonth': string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeeSelectCompanyRequest
     */
    'cardAccountUnit'?: UpdateFreeeSelectCompanyRequestCardAccountUnitEnum;
}

export const UpdateFreeeSelectCompanyRequestCardAccountUnitEnum = {
    all: 'ALL',
    group: 'GROUP',
    single: 'SINGLE'
} as const;

export type UpdateFreeeSelectCompanyRequestCardAccountUnitEnum = typeof UpdateFreeeSelectCompanyRequestCardAccountUnitEnum[keyof typeof UpdateFreeeSelectCompanyRequestCardAccountUnitEnum];


